exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'cat';\n  src: url(\"/assets/fonts/cat.eot?vcfb5d\");\n  src: url(\"/assets/fonts/cat.eot?vcfb5d#iefix\") format(\"embedded-opentype\"), url(\"/assets/fonts/cat.ttf?vcfb5d\") format(\"truetype\"), url(\"/assets/fonts/cat.woff?vcfb5d\") format(\"woff\"), url(\"/assets/fonts/cat.svg?vcfb5d#cat\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n:host {\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n  :host .modal-body {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1; }\n  :host .modal-header {\n    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n    font-size: 12px;\n    line-height: 13.2px;\n    text-transform: uppercase;\n    color: #eeeeee;\n    background: #2f30ff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-form/components/modal-multi-select/modal-multi-select.component.scss
// module id = ../../../../../src/app/modules/ui-form/components/modal-multi-select/modal-multi-select.component.scss
// module chunks = main